import * as React from "react";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import "./styles.scss";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";

const CreditCardInfoChangeFinishPage = () => {
    return (
        <MainLayout>
            <Headline>変更完了</Headline>
            <section className="payment-change-finish">
                <p className="finish-message">
                    クレジットカードを変更しました。　
                    <br />
                    次回の自動更新日より適用されます。
                </p>

                <div className="user-action">
                    <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                    <LinkButton color="secondary" to={URL_PATHS.myPage()}>
                        マイページへ
                    </LinkButton>
                </div>
            </section>
        </MainLayout>
    );
};

export default CreditCardInfoChangeFinishPage;
